import React, { ChangeEvent, Component } from "react";

import { ITags } from "@formant/core/model/ITags";
import { IValidation } from "@formant/core/model/IValidation";
import { IWebhook } from "@formant/core/model/IWebhook";
import { InputElement } from "@formant/ui/component/common/Field";
import { TextField } from "@formant/ui/component/common/TextField";

import { EditTags } from "../../common/EditTags";
import { IconButton } from "../../common/IconButton";
import { ValidationMessages } from "../../common/ValidationMessages";
import * as styles from "./WebhooksRow.scss";

export interface IWebhooksRowProps {
    webhook: IWebhook;
    index: number;
    validation: IValidation;
    onEdit: (index: number, webhook: IWebhook) => void;
    onDelete: (index: number) => void;
}

export class WebhooksRow extends Component<IWebhooksRowProps> {
    public render() {
        const { onChangeName, onChangeUrl, onChangeHeaders, onDelete } = this;
        const {
            webhook: { name, url, headers },
            index,
            validation,
        } = this.props;

        const nameValidationKey = `webhooksInfo.webhooks.${index}.name`;
        const urlValidationKey = `webhooksInfo.webhooks.${index}.url`;
        const headersValidationKey = `webhooksInfo.webhooks.${index}.headers`;

        const nameValidation = validation[nameValidationKey];
        const urlValidation = validation[urlValidationKey];
        const headersValidation = validation[headersValidationKey];
        const invalid = nameValidation || urlValidation || headersValidation;

        return (
            <>
                <tr className={styles["table-row"]}>
                    <td>
                        <TextField
                            label="Name"
                            value={name}
                            collapsed={true}
                            small={true}
                            onChange={onChangeName}
                            invalid={!!nameValidation}
                        />
                    </td>
                    <td>
                        <TextField
                            label="URL"
                            value={url}
                            collapsed={true}
                            small={true}
                            onChange={onChangeUrl}
                            invalid={!!urlValidation}
                        />
                    </td>
                    <td>
                        <EditTags
                            value={headers || {}}
                            small={true}
                            tags={{}}
                            keys={[]}
                            description="Add headers"
                            onChange={onChangeHeaders}
                            invalid={!!headersValidation}
                            disableInheritedTags={true}
                        />
                    </td>
                    <td>
                        <IconButton icon="delete" onClicked={onDelete} />
                    </td>
                </tr>
                {invalid && (
                    <tr>
                        <td>
                            <ValidationMessages
                                validation={validation}
                                keys={[nameValidationKey]}
                                className={styles.validation}
                            />
                        </td>
                        <td>
                            <ValidationMessages
                                validation={validation}
                                keys={[urlValidationKey]}
                                className={styles.validation}
                            />
                        </td>
                        <td>
                            <ValidationMessages
                                validation={validation}
                                keys={[headersValidationKey]}
                                className={styles.validation}
                            />
                        </td>
                    </tr>
                )}
            </>
        );
    }

    private onChangeName = (event: ChangeEvent<InputElement>) => {
        const { index, webhook, onEdit } = this.props;
        const name = event.target.value;
        onEdit(index, { ...webhook, name });
    };

    private onChangeUrl = (event: ChangeEvent<InputElement>) => {
        const { index, webhook, onEdit } = this.props;
        const url = event.target.value;
        onEdit(index, { ...webhook, url });
    };

    private onChangeHeaders = (headers: ITags) => {
        const { index, webhook, onEdit } = this.props;
        onEdit(index, { ...webhook, headers });
    };

    private onDelete = () => {
        const { index, onDelete } = this.props;
        onDelete(index);
    };
}
